import type { ReactElement } from "react"
import React from "react"
import { typeMatches } from "@onestore-graphql"
import type { ButtonAtmProps } from "@onestore/hel/dist/components/atoms/ButtonAtm"
import FormilyFormButton from "@gatsby-plugin-generic-page/components/FormilyFormButton"
import type { Formily } from "@gatsby-plugin-generic-page/fragments/formily"
import { SquidexFormType } from "@gatsby-plugin-generic-page/types/formType"
import { Forms } from "~/types/squidex"

interface Props
  extends Pick<
    ButtonAtmProps,
    | "color"
    | "variant"
    | "title"
    | "text"
    | "isWider"
    | "rel"
    | "size"
    | "isExpanded"
    | "isExpandedOnMobile"
  > {
  form: Forms[]
}

function FormButton({
  color = "primary",
  form,
  text,
  title,
  isWider,
  isExpanded,
  isExpandedOnMobile,
  variant,
  rel,
  size,
}: Props): ReactElement<Props> | null {
  const { __typename } = form[0]

  if (!typeMatches(__typename, SquidexFormType.FORMILY_FORM)) {
    return null
  }

  return (
    <FormilyFormButton
      button={{
        color,
        text,
        title,
        isWider,
        isExpanded,
        isExpandedOnMobile,
        variant,
        rel,
        size,
      }}
      formilyForm={form[0] as Formily}
    />
  )
}

export default FormButton
